import React, { useState } from "react";
import { QrReader } from '@blackbox-vision/react-qr-reader';
import "./ListMontagem.css";

export default function QRCodeReaderListaMontagem({ setCode }) {
  const [cameraAtiva, setCameraAtiva] = useState(false);

  const handleError = (err) => {
    console.error('Erro na leitura do QR Code:', err);
  };

  // onResult signature pode ser (result, error) dependendo da versão
  const handleScan = (result, error) => {
    if (error) {
      // alguns erros aparecem constantemente (ex: track not ready) — apenas log
      console.debug('QR reader error:', error);
      return;
    }

    if (!result) return;

    console.log('QR result raw:', result);

    // Normaliza vários formatos possíveis de retorno
    let texto = null;
    if (typeof result === "string") {
      texto = result;
    } else if (result?.text) {
      texto = result.text;
    } else if (typeof result?.getText === "function") {
      try {
        texto = result.getText();
      } catch (e) {
        console.debug('getText falhou', e);
      }
    }

    if (texto) {
      // envia pro pai e fecha a câmera com pequeno debounce para evitar duplicatas
      setCode(texto);
      setTimeout(() => setCameraAtiva(false), 200);
    }
  };

  return (
    <div className="qrWrapper_listaMontagem">
      <button className="btnAbrirCamera" onClick={() => setCameraAtiva((prev) => !prev)}>
        <span role="img" aria-label="camera" style={{ fontSize: "1.2em" }}>📷</span>
        {cameraAtiva ? "Fechar Leitor" : "Ler QR Code"}
      </button>

      {cameraAtiva && (
        <div className="qrCameraBox">
          <QrReader
            onError={handleError}
            onResult={handleScan}
            constraints={{
              // usar ideal para permitir ao navegador escolher a melhor configuração
              facingMode: { ideal: "environment" },
              width: { ideal: 640 },
              height: { ideal: 480 },
            }}
            videoStyle={{ width: "100%", height: "100%", objectFit: "cover" }}
            style={{ width: "100%", height: "100%" }}
            delay={150} // menor delay para resposta mais rápida
          />
          <div className="qrOverlayCenter" aria-hidden="true"></div>
        </div>
      )}
    </div>
  );
}